import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

/**
 * Shown ~5 minutes before local session expiry.
 */
const SessionWarningModal = ({
  open,
  onContinue,
  onLogout,
  continuing = false,
}) => (
  <Dialog
    open={open}
    onClose={() => {}}
    disableEscapeKeyDown
    aria-labelledby="session-warning-title"
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle id="session-warning-title">Session expiring soon</DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ mb: 1 }}>
        Your session will expire in 5 minutes. Continue session?
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Choose Continue to stay signed in, or Logout to end your session safely.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button
        onClick={onLogout}
        color="inherit"
        disabled={continuing}
      >
        Logout
      </Button>
      <Button
        onClick={onContinue}
        variant="contained"
        disabled={continuing}
        autoFocus
      >
        {continuing ? "Refreshing…" : "Continue Session"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default SessionWarningModal;
